export const iconpath: string = "/assets/icons/";
export const imagepath: string = "/assets/images/";
export const bannerpath: string = "/assets/banner/";
